//import services from './../services/service'; // Service Class
//let service = new services();

export default {
    name: 'Settings',
    data () {
      return {
        disable_btn:false,
        action_loading:false,
        copied:false,
        //
        site_view:1,//mobile
      }
  },

    methods: {
        back(){
            window.history.back();
        },
        
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        formatCurrency(currency){
            currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
            currency =  currency.replace("₦", "") //if sign showing as in Edge browser
            currency =  currency.replace("NGN", ""); //strip off NGN
            return currency;
        },

        formatCurrency_2(currency){
            currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
            currency =  currency.replace("₦", "") //if sign showing as in Edge browser
            currency =  currency.replace("NGN", ""); //strip off NGN
            currency =  currency.replace(".00", ""); //strip off NGN
            currency =  currency.replace(" ", ""); //strip off any space
            return currency;
        },

        copyLink(link,id) {
            this.$clipboard(link);
            this.copied = true;
            document.getElementById(id).style.display = "block";
        },

        toggleSingleComponent(component){
            let toggle = document.getElementById(component).style.display;
            if(toggle == "block"){
                document.getElementById(component).style.display = "none";
            }else{
                document.getElementById(component).style.display = "block";
            }
        },
        
        //screen-views
        screenFunction(x) {
            if (x.matches) { // If media query matches
                this.site_view = 1;
            } else {
                this.site_view = 2;
            }
        }
        //./screen-views
        
    },
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/resources/setts.js